var _G, _Path, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function SvgAppleHealth(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#apple-health_svg__filter0_ddd_18135_2269)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M20.353 1.6c2.88 0 4.32 0 5.888.48a6.054 6.054 0 013.648 3.648c.512 1.568.512 3.04.512 5.92v8.704c0 2.88 0 4.32-.48 5.888a6.054 6.054 0 01-3.648 3.648c-1.6.512-3.04.512-5.92.512h-8.704c-2.88 0-4.32 0-5.888-.48a6.156 6.156 0 01-3.68-3.68c-.48-1.536-.48-2.976-.48-5.888v-8.704c0-2.88 0-4.32.48-5.888.64-1.696 1.952-3.04 3.68-3.648C7.297 1.6 8.737 1.6 11.649 1.6h8.704z",
    fill: "#fff"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M25.825 10.24c0-2.176-1.664-3.84-3.584-3.84-1.344 0-2.432.448-3.104 1.44-.672-.992-1.76-1.44-2.88-1.44-2.176 0-3.84 1.664-3.84 3.84 0-.096 0-.064 0 0 0 3.232 3.104 6.496 6.72 7.904 2.816-.928 6.688-4.672 6.688-7.904 0-.064 0-.096 0 0z",
    fill: "url(#apple-health_svg__paint0_linear_18135_2269)"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "apple-health_svg__paint0_linear_18135_2269",
    x1: 19.115,
    y1: 6.409,
    x2: 19.115,
    y2: 18.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FF61AD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FF2719"
  })))));
}

export default SvgAppleHealth;